module.exports = __webpack_public_path__ + "media/images/camera_plus-9bea335e5c5ec21fd303172bbc2da43e37d8cad972354e1fabe73fb29f6267ff.svg";